import { render, staticRenderFns } from "./SeparadorTrocaAtendente.vue?vue&type=template&id=f174ee98&scoped=true"
import script from "./SeparadorTrocaAtendente.vue?vue&type=script&lang=js"
export * from "./SeparadorTrocaAtendente.vue?vue&type=script&lang=js"
import style0 from "./SeparadorTrocaAtendente.vue?vue&type=style&index=0&id=f174ee98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f174ee98",
  null
  
)

export default component.exports